import { render, staticRenderFns } from "./cashback.vue?vue&type=template&id=0989a235"
import script from "./cashback.vue?vue&type=script&lang=js"
export * from "./cashback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports